import React, { useState, useEffect } from 'react';
import remarkGfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

interface Notification {
  id: string;
  title: string;
  message: string;
  url: string;
  acknowledged: boolean;
  seen: boolean;
}

const MyNotifications = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true); // Add loading state

  // API CALLS FOR NOTIFICATIONS
  useEffect(() => {
    fetch('/notifications/', {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        setNotifications(data);
        setLoading(false); // Stop loading
      })
      .catch((error) => {
        console.error('Error fetching notifications:', error);
        setLoading(false); // Stop loading in case of error
      });
  }, []);

  const handleNotifyClick = (id: string, url: string) => {
    const encodedUrl = encodeURIComponent(url);
    window.location.href = `/notifications/${id}/acknowledge?redirect=${encodedUrl}`;
  };

  const handleKeyDown = (e: React.KeyboardEvent, id: string, url: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleNotifyClick(id, url);
    }
  };

  const notificationStateClass = (notification: Notification) => {
    if (notification.acknowledged) return 'notification-state-acknowledged';
    if (notification.seen) return 'notification-state-seen';
    return 'notification-state-unseen';
  };

  // Handle DELETE/HIDE notificarions
  const hideNotification = async (id: string) => {
    try {
      const response = await fetch(`/notifications/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ hide: true }),
      });

      if (!response.ok) {
        throw new Error('Error hiding notification');
      }

      // Update the local state to remove the hidden notification
      setNotifications((prevNotifications) =>
        prevNotifications.filter((notification) => notification.id !== id)
      );
    } catch (error) {
      console.error('Error updating notification:', error);
    }
  };


  return (
    <div>

      <div className="page-header">
        <h3 className="page-title">Notifications</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Notifications</li>
          </ol>
        </nav>
      </div>

      {loading ? (
        <div>
          <h4>Loading</h4>
        </div>
      ) : notifications.length > 0 ? (
        <div className="notify_container">
          {notifications.map((notification, index) => (
            <div
              key={index}
              onKeyDown={(e) => handleKeyDown(e, notification.id, notification.url)}
              onClick={() => handleNotifyClick(notification.id, notification.url)}
              className={`notif_item ${notificationStateClass(notification)}`}
              role="button"
              tabIndex={0}
            >
              <div className='item_div'>
                <h3>{notification.title}</h3>
                <p><ReactMarkdown remarkPlugins={[remarkGfm]}>{notification.message}</ReactMarkdown></p>
              </div>

              <div className='delete_icon'>
                <DeleteOutlineOutlinedIcon
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation(); // Prevents triggering the parent click event
                    hideNotification(notification.id);
                  }}
                  className='mui_ic'/>
              </div>
            </div>
          ))}
        </div>
      ) : (
          "You have no notifications"
      )}
    </div>
  );
};

export default MyNotifications;
